import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as core from '../../core'

export namespace Filter {
  export type Option = core.common.Identified<Option.Id> &
    core.common.Named &
    core.common.Coded & {
      prefix?: string
    }
  export namespace Option {
    export type Id = core.dms.data.Record.Id

    export interface Criteria {
      entityId: core.dms.models.Entity.Id
      ancestorEntityId?: core.dms.models.Entity.Id
      ancestorIds?: readonly core.dms.data.Record.Id[]
      recordIds?: readonly core.dms.data.Record.Id[]
    }
    export namespace Criteria {
      export const isCriteria: TypeChecker<Criteria> =
        TypeChecker.Factory.object({
          ancestorEntityId: TypeChecker.Factory.optional(
            core.dms.models.Entity.Id.isId,
          ),
          ancestorIds: TypeChecker.Factory.optional(
            TypeChecker.Factory.list(core.dms.data.Record.Id.isId),
          ),
          entityId: core.dms.models.Entity.Id.isId,
        })
      export const assertIsCriteria: TypeAsserter<Criteria> =
        TypeAsserter.Factory.from(isCriteria)
    }
  }
}
